import React, { useEffect } from 'react';
import gsap from 'gsap';
import { offer } from '../../assets/Assets';
import './Offer.scss';
import { useHistory } from 'react-router-dom';

function Offer() {
  const history = useHistory();

  useEffect(() => {
    let tl = gsap.timeline({
      ease: 'power0',
      scrollTrigger: {
        trigger: '.offer img',
        start: 'top 75%',
        end: 'bottom 25%',
        toggleActions: 'play',
      },
    });
    tl.from('.offer h1', {
      y: '-14vw',
      duration: 1,
    })
      .from(
        '.offer img',
        {
          skewX: '40deg',
          scale: 0.5,
          opacity: 0,
        },
        '<.8'
      )
      .from('.offer button', {
        opacity: 0,
        scale: 1.2,
      });
  }, []);

  return (
    <>
      <section className="offer" id="offer">
        <div className="box">
          <h1>
            Have any Project? <hr />{' '}
          </h1>
        </div>
        <article>
          <img src={offer} alt="offer" />
          <div>
            <h2>Interest to work with me? </h2>
            <p>Just DM's me on instagram for a chat, i won't bite though :)</p>
            <button
              onClick={() => {
                history.push('/contact');
                window.scrollTo(0, 0);
              }}
            >
              Contact / Message me
            </button>
          </div>
        </article>
      </section>
    </>
  );
}

export default Offer;
